

import VesselMonitoringBay from '@/view/pages/vesselMonitoring/components/VesselMonitoringBay/VesselMonitoringBay.vue'
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    VesselMonitoringBay
  },
  props: {
    vesselHatch: { type: Object as () => any, default: () => ({ vesselBays: [] }) },
    minDeckTiersNo:{default: 0},
    minHoldTiersNo:{default: 0},
    maxRows:{default:0},
    cellWidth: { default: null }
  },
  mounted() {
  },
  computed: {
    ...mapGetters(["getVesselMonitoringData"]),
    
    vesselMonitoringData() {
      return this.getVesselMonitoringData;
    }
  },
}
